import React from 'react';
import {connect} from 'react-redux';
import {submit, startSubmit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {MODALS, fetchBooking} from 'ducks/bookings';

import {CreateOfferForm, Buttons} from './components';

class CreateOfferModal extends React.Component<any> {
  submitForm = () => {
    this.props.submit('createBookingOffer');
  };

  getExtraActions = () => {
    const {data: {locationRef, bookingId}} = this.props;

    return [
      ...this.props.closeModalExtraActions,
      () => fetchBooking({locationRef, bookingId})
    ];
  };

  render() {
    const {form: {submitting}, data: {bookingId}} = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.EXTRA_SMALL}
        className="CreateOfferModal">
        <Modal.Header heading="Create booking offer" />
        <Modal.Body>
          <CreateOfferForm
            bookingId={bookingId}
            getExtraActions={this.getExtraActions}
          />
        </Modal.Body>

        <Modal.Footer>
          <Buttons submitForm={this.submitForm} submitting={submitting} />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  form: {
    submitting: isSubmitting('createBookingOffer')(state)
  }
});

const mapDispatchToProps = {startSubmit, submit};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.CREATE_OFFER)(CreateOfferModal)
);
